import api from '../api';
export default { create(interviewId) { const path = `/internal/api/v1/application_interviews/${interviewId}/reschedule`; return api({ method: 'post', url: path }); } };
